(function () {
// SCRIPT SENHA LOGIN
function $6074568c9c4450be$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == 'text' ? 'password' : 'text';
            if (input.type == 'text') item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector('.password');
        buttonPass.addEventListener('click', handleEvent(div));
    });
}


function $2914c72b259257f0$export$2e2bcd8739ae039() {
    const allFormsErrors = document.querySelectorAll("[id^='form-errors']");
    allFormsErrors.forEach((formErrors)=>showErrors(formErrors));
    function showErrors(formErrors) {
        const errorsText = formErrors.textContent;
        const errors = JSON.parse(errorsText).__all__;
        errors && errors.forEach((error)=>error ? GLOBAL.showToastify(error) : "");
    }
}


function $dde89147b3a6dc75$export$2e2bcd8739ae039() {
    window.addEventListener("scroll", function() {
        const headerEl = document.querySelector("#menu");
        headerEl.classList.toggle("sticky", window.scrollY > 550);
    });
    const btnMobile = document.getElementById('btn-mobile');
    function toggleMenu() {
        const nav = document.getElementById('navigation');
        nav.classList.toggle('active');
    }
    btnMobile.addEventListener('click', toggleMenu);
}


function $4937a915b72f1eb1$export$2e2bcd8739ae039() {
    // SWIPER
    const swiperNossoTime = new Swiper(".teste", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
            540: {
                slidesPerView: 2.2,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 30
            }
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });
}


function $08a0bb1a2b8dee1f$export$2e2bcd8739ae039() {
    const items = document.querySelectorAll('.associacoes-lis-item');
    function toggleContent(item) {
        const text = item.querySelector('.content');
        const icon = item.querySelector('.icon');
        text.classList.toggle('show');
        icon.classList.toggle('active');
    }
    function handleClick() {
        const item = this.closest('.associacoes-lis-item');
        toggleContent(item);
    }
    items.forEach((item)=>{
        const icon = item.querySelector('.icon');
        icon.addEventListener('click', handleClick);
    });
}


function $4e4a35de138e9f7d$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#form-submit");
    console.log(contatoFormSubmit);
    contatoFormSubmit && contatoFormSubmit.addEventListener("submit", function(event) {
        event.preventDefault();
        disabledBtn();
        // const form_data = {
        //     nome: document.querySelector('#nome').value,
        //     email: document.querySelector('#email').value,
        //     mensagem: document.querySelector('#mensagem').value,
        // }
        const formData = new FormData();
        formData.append("nome", document.querySelector("#form-submit input[name=nome]").value);
        formData.append("email", document.querySelector("#form-submit input[name=email]").value);
        // formData.append('telefone', document.querySelector('#form-submit input[name=telefone]').value);
        formData.append("mensagem", document.querySelector("#form-submit textarea[name=mensagem]").value);
        if (document.querySelector("#form-submit input[name=arquivo]")) formData.append("arquivo", document.querySelector("#form-submit input[name=arquivo]").files[0]);
        const url = "/fale-conosco/";
        axios.post(url, formData).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector(".contato-form .btn");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.style.opacity = "0.5";
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.style.opacity = "1.0";
    }
    const fileImage = document.querySelector('input[type="file"]');
    const textLabel = document.querySelector(".select-file");
    fileImage && fileImage.addEventListener("change", ()=>{
        textLabel.innerText = fileImage.value.slice(12);
    });
}


function $999c07c981819f1e$export$2e2bcd8739ae039() {
    const contatoIbaFormSubmit = document.querySelector("#form-submit-iba");
    contatoIbaFormSubmit && contatoIbaFormSubmit.addEventListener("submit", function(event) {
        event.preventDefault();
        disabledBtn();
        const formData = new FormData();
        formData.append("nome", document.querySelector("#form-submit-iba input[name=nome]").value);
        formData.append("empresa", document.querySelector("#form-submit-iba input[name=empresa]").value);
        formData.append("email", document.querySelector("#form-submit-iba input[name=email]").value);
        formData.append("data", document.querySelector("#form-submit-iba select[name=data]").selectedOptions[0].text);
        formData.append("horario", document.querySelector("#form-submit-iba select[name=horario]").selectedOptions[0].text);
        const url = "/contato-iba/";
        axios.post(url, formData).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoIbaFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector("#form-submit-iba .btn");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.style.opacity = "0.5";
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.style.opacity = "1.0";
    }
}


function $e7d2b4c92d82f8e3$export$2e2bcd8739ae039() {
    const itemsLista = document.querySelectorAll('.item-lista');
    const conteudo = document.querySelectorAll('.tab-content');
    itemsLista.forEach((item, index)=>{
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const tab = e.target.closest(".item-lista");
            const tabId = tab.dataset.tabContent;
            itemsLista.forEach((cont)=>cont.classList.remove('ativo'));
            tab.classList.add('ativo');
            conteudo.forEach((item)=>item.classList.remove('ativo'));
            const currentContent = document.querySelector(`.${tabId}`);
            if (currentContent) currentContent.classList.add("ativo");
        });
    });
}


const $e45bd7d33e1e9fe5$var$Translate = ()=>{
    function change_language(language) {
        const value = `/auto/${language}`;
        const hostname = window.location.hostname;
        // Sempre funciona
        document.cookie = `googtrans=${value};path=/`;
        // Só adiciona domain fora de localhost
        if (hostname !== "localhost" && hostname !== "127.0.0.1") document.cookie = `googtrans=${value};path=/;domain=${hostname}`;
        localStorage.setItem('language-abbreviation', language);
        // Reload necessário pro Google aplicar tradução
        window.location.reload();
    }
    function addEvent() {
        const selectsLang = document.querySelectorAll('.box-lang li');
        selectsLang.forEach((li)=>{
            li.onclick = null;
            li.onclick = (e)=>{
                e.preventDefault();
                const text = e.currentTarget.textContent.trim().toLowerCase();
                change_language(text);
            };
        });
    }
    function initTranslate() {
        window.googleTranslateElementInit = function() {
            new google.translate.TranslateElement({
                pageLanguage: 'pt',
                includedLanguages: 'pt,en,es',
                autoDisplay: false
            }, 'google_translate_element');
        };
        if (!document.getElementById("google-translate-script")) {
            const script = document.createElement("script");
            script.id = "google-translate-script";
            script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            document.body.appendChild(script);
        }
    }
    function main() {
        addEvent();
        initTranslate();
    }
    if (document.readyState === 'complete') main();
    else window.addEventListener('load', main);
};
var $e45bd7d33e1e9fe5$export$2e2bcd8739ae039 = $e45bd7d33e1e9fe5$var$Translate;


const $3ef47403202fb23b$var$SelectConfig = (classSelect)=>{
    // 1. Construtor de itens com bloqueio de tradução (evita "en" -> "em")
    function construct_li(src, text) {
        const langCode = text.toLowerCase().trim();
        return `
            <li data-lang="${langCode}" class="notranslate" translate="no">
                <img src="${src}" alt="" class="notranslate" />
                <p class="notranslate"><span class="notranslate" translate="no">${text}</span></p>
            </li>
        `;
    }
    // 2. Construtor da lista suspensa
    function construct_ul(options, classUL) {
        let LIs = '';
        options.forEach((option)=>{
            LIs += construct_li(option.getAttribute("data-icone"), option.value);
        });
        return `<ul class="${classUL} notranslate" translate="no">${LIs}</ul>`;
    }
    // 3. Injeção visual do componente no DOM
    function construct_element_select(selects, selectedOption, UL, className) {
        selects.forEach((select, i)=>{
            const parent = select.parentElement;
            if (parent.querySelector(`.${className}`)) return;
            parent.insertAdjacentHTML('beforeend', `
                <div class='${className} ${className}-${i + 1} notranslate' translate="no">
                    <div class="select-option notranslate" translate="no">
                        <img src="${selectedOption.getAttribute("data-icone")}" class="notranslate" />
                        <p class="notranslate" translate="no">${selectedOption.value}</p>
                        <svg width="9" height="6" class="notranslate">
                            <path d="M4.64866 5.33482C4.56921 5.4231 4.43079 5.4231 4.35134 5.33482L0.300414 0.833793C0.18458 0.705089 0.275918 0.5 0.449072 0.5L8.55093 0.5C8.72408 0.5 8.81542 0.705088 8.69959 0.833793L4.64866 5.33482Z" fill="#6BB6EF"/>
                        </svg>
                    </div>
                    ${UL}
                </div>
            `);
        });
    }
    // 4. Lógica de Eventos Blindada (Resolve Clique Duplo e Erro de Cookie)
    function setupEvents(boxClass, ulClass, selectClass, classSelect) {
        const boxes = document.querySelectorAll(`[class*="${boxClass}"]`);
        boxes.forEach((box)=>{
            const selectOption = box.querySelector(`.${selectClass}`);
            const ul = box.querySelector(`.${ulClass}`);
            const svg = selectOption?.querySelector("svg");
            const selects = document.querySelectorAll(`${classSelect}`);
            console.log(selectOption);
            if (selectOption) selectOption.onclick = (e)=>{
                e.stopPropagation();
                const isActive = ul.classList.contains("active");
                document.querySelectorAll(`.${ulClass}`).forEach((el)=>el.classList.remove("active"));
                if (!isActive) {
                    ul.classList.add("active");
                    svg?.classList.add("active");
                }
            };
            const options = box.querySelectorAll(`.${ulClass} li`);
            options.forEach((option)=>{
                option.addEventListener("click", (e)=>{
                    const lang = e.target.getAttribute("data-lang");
                    const paragraph = selectOption.querySelector("p");
                    if (paragraph) paragraph.textContent = lang.toUpperCase();
                });
                option.onclick = (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const el = e.currentTarget;
                    const img = el.querySelector("img").src;
                    const langCode = el.getAttribute("data-lang");
                    const visibleText = el.querySelector("span").innerText;
                    // A. Atualiza UI Visual
                    selectOption.querySelector("img").src = img;
                    selectOption.querySelector("p").innerText = visibleText;
                    ul.classList.remove("active");
                    svg?.classList.remove("active");
                    // B. CORREÇÃO DO ERRO DE DOMÍNIO (Cookie manual)
                    // Limpamos e setamos o cookie no path correto para evitar rejeição do browser
                    document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    document.cookie = `googtrans=/pt/${langCode}; path=/;`;
                    // C. SINCRONIA COM O GOOGLE (Evita clique duplo)
                    selects.forEach((select)=>{
                        // Resetamos o valor para garantir que o motor do Google dispare o evento
                        select.value = "";
                        setTimeout(()=>{
                            select.value = langCode;
                            // Disparamos o evento 'change' que o Google monitora
                            select.dispatchEvent(new Event('change', {
                                bubbles: true
                            }));
                            // Salva preferência local
                            localStorage.setItem('language-abbreviation', langCode);
                        }, 150);
                    });
                    // D. Caso especial PT (Restaurar Original)
                    if (langCode === 'pt') setTimeout(()=>{
                        const frame = document.querySelector('.goog-te-banner-frame iframe');
                        if (frame) try {
                            const innerDoc = frame.contentDocument || frame.contentWindow.document;
                            const restoreBtn = innerDoc.querySelector('button[id*="confirm"]');
                            if (restoreBtn) restoreBtn.click();
                        } catch (err) {}
                    }, 500);
                };
            });
        });
    }
    function main() {
        const BoxName = "box-lang";
        const ULName = "ul_select_lang";
        const SelectOptionName = "select-option";
        const selects = document.querySelectorAll(`${classSelect}`);
        if (!selects.length) return;
        // Limpa instâncias duplicadas (previne erros do Parcel/HMR)
        document.querySelectorAll(`.${BoxName}`).forEach((el)=>el.remove());
        const options = Array.from(selects[0].options);
        const UL = construct_ul(options, ULName);
        const savedLang = localStorage.getItem('language-abbreviation') || 'pt';
        const selected = options.find((opt)=>opt.value.toLowerCase() === savedLang) || options[0];
        construct_element_select(selects, selected, UL, BoxName);
        setupEvents(BoxName, ULName, SelectOptionName, classSelect);
        // Fechar ao clicar fora
        document.removeEventListener("click", closeAll);
        document.addEventListener("click", closeAll);
    }
    function closeAll() {
        document.querySelectorAll(".ul_select_lang").forEach((u)=>u.classList.remove("active"));
        document.querySelectorAll(".select-option svg").forEach((s)=>s.classList.remove("active"));
    }
    // Inicialização robusta baseada no estado do carregamento
    if (document.readyState === "complete" || document.readyState === "interactive") main();
    else window.addEventListener("load", main);
};
var $3ef47403202fb23b$export$2e2bcd8739ae039 = $3ef47403202fb23b$var$SelectConfig;


function $20b7ac172908ca81$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector('.form-newsletter');
    contatoFormSubmit && contatoFormSubmit.addEventListener('submit', function(event) {
        event.preventDefault();
        disabledBtn();
        const form_data = {
            email: document.querySelector('#email').value
        };
        const url = "/cadastro_newsletter/";
        axios.post(url, form_data).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector(".form-newsletter .btn-newslleter");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.style.opacity = "0.5";
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.style.opacity = "1.0";
    }
}


function $cb94ac20dc347dbd$export$2e2bcd8739ae039() {
    const tabPremio = document.querySelectorAll(".item-lista");
    const tabConteudo = document.querySelectorAll('.tab-content');
    const urlParams = new URLSearchParams(window.location.search);
    const dataParam = urlParams.get('data');
    console.log(dataParam);
    if (dataParam || dataParam == "") {
        tabPremio.forEach((i)=>i.classList.remove('ativo'));
        tabConteudo.forEach((i)=>i.classList.remove('ativo'));
        tabConteudo[1].classList.add('ativo');
        tabPremio[1].classList.add('ativo');
    }
}


function $573220700407d05d$export$2e2bcd8739ae039() {
    const lista = document.querySelectorAll('.button-equipe-mobile');
    lista.forEach((i)=>{
        i.addEventListener('click', (e)=>{
            const pai = e.target.closest('.list-socios');
            pai.classList.add('mostrar-todos');
        });
    });
}


function $e1031f0fb6508262$export$2e2bcd8739ae039() {
    function richTextParse() {
        function parseJSONToHTML(json) {
            const data = JSON.parse(json);
            console.log(data);
            let html = "";
            for (const block of data.blocks)switch(block.type){
                case "paragraph":
                    html += `<p class="paragraph">${block.data.text}</p>`;
                    break;
                case "Header":
                    html += `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                    break;
                case "Table":
                    html += `<table class="table">${block.data.content}</table>`;
                    break;
                case "Raw":
                    html += `<div class="raw">${block.data.html}</div>`;
                    break;
                case "Delimiter":
                    html += '<hr class="delimiter">';
                    break;
                case "Code":
                    html += `<pre class="code"><code>${block.data.code}</code></pre>`;
                    break;
                case "Quote":
                    html += `<blockquote class="quote">${block.data.text}</blockquote>`;
                    break;
                case "List":
                    const listItems = block.data.items.map((item)=>`<li>${item}</li>`).join("");
                    const listStyle = block.data.style === "ordered" ? "ol" : "ul";
                    html += `<${listStyle} class="list">${listItems}</${listStyle}>`;
                    break;
                case "Embed":
                    html += `<div class="embed ${block.data.service}">
								<iframe width="560" height="315" src="${block.data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
								</div>`;
                    break;
                case "Checklist":
                    const checklistItems = block.data.items.map((item)=>{
                        const checked = item.checked ? "checked" : "";
                        return `<li>
									<input  type="checkbox" onclick="return false;"  ${checked}>
									<label> ${item.text} </label>
									</li>`;
                    }).join("");
                    html += `<ul>${checklistItems}</ul>`;
                    break;
                case "Image":
                    html += `<img src="${block.data.file.url}" alt="${block.data.caption}" class="image">`;
                    break;
                case "Warning":
                    html += `<div class="warning">
															<h3>${block.data.title}</h3>
															<p>${block.data.message}</p>
															</div>`;
                    break;
                default:
                    break;
            }
            return html;
        }
        const blogContent = document.querySelectorAll(".blog-content");
        let inputs = document.querySelectorAll(".form-content");
        let texts = document.querySelectorAll(".content-area");
        const selectTab = document.querySelector(".select-wrapper select");
        function showContent(tabId) {
            texts.forEach((item)=>item.classList.remove("active"));
            const currentContent = document.querySelector(`.${tabId}`);
            if (currentContent) currentContent.classList.add("active");
        }
        inputs.forEach((item, index)=>{
            item.addEventListener("click", (e)=>{
                const tab = e.target.closest(".form-content");
                const tabId = tab.dataset.tabContent;
                showContent(tabId);
            });
        });
        selectTab.addEventListener("change", (e)=>{
            const tabId = selectTab.value;
            if (tabId) showContent(tabId);
        });
        blogContent.forEach((blog)=>{
            if (blog.dataset.conteudo) {
                const htmlParsed = parseJSONToHTML(blog.dataset.conteudo);
                console.log(htmlParsed);
                blog.innerHTML = htmlParsed;
            } else console.log("SEM CONTEUDO ;");
        });
    }
    richTextParse();
}


function $c575fedb0aafb31c$export$2e2bcd8739ae039() {
    function richTextParse() {
        function parseJSONToHTML(json) {
            const data = JSON.parse(json);
            let html = "";
            for (const block of data.blocks)switch(block.type){
                case "paragraph":
                    html += `<p class="paragraph">${block.data.text}</p>`;
                    break;
                case "Header":
                    html += `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                    break;
                case "Table":
                    html += `<table class="table">${block.data.content}</table>`;
                    break;
                case "Raw":
                    html += `<div class="raw">${block.data.html}</div>`;
                    break;
                case "Delimiter":
                    html += '<hr class="delimiter">';
                    break;
                case "Code":
                    html += `<pre class="code"><code>${block.data.code}</code></pre>`;
                    break;
                case "Quote":
                    html += `<blockquote class="quote">${block.data.text}</blockquote>`;
                    break;
                case "List":
                    const listItems = block.data.items.map((item)=>`<li>${item}</li>`).join("");
                    const listStyle = block.data.style === "ordered" ? "ol" : "ul";
                    html += `<${listStyle} class="list">${listItems}</${listStyle}>`;
                    break;
                case "Embed":
                    html += `<div class="embed ${block.data.service}">
								<iframe width="560" height="315" src="${block.data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
								</div>`;
                    break;
                case "Checklist":
                    const checklistItems = block.data.items.map((item)=>{
                        const checked = item.checked ? "checked" : "";
                        return `<li>
									<input  type="checkbox" onclick="return false;"  ${checked}>
									<label> ${item.text} </label>
									</li>`;
                    }).join("");
                    html += `<ul>${checklistItems}</ul>`;
                    break;
                case "Image":
                    html += `<img src="${block.data.file.url}" alt="${block.data.caption}" class="image">`;
                    break;
                case "Warning":
                    html += `<div class="warning">
															<h3>${block.data.title}</h3>
															<p>${block.data.message}</p>
															</div>`;
                    break;
                default:
                    break;
            }
            return html;
        }
        const blogContent = document.querySelectorAll(".text-content");
        blogContent.forEach((blogContent)=>{
            if (blogContent.dataset.conteudo_home) {
                const htmlParsed = parseJSONToHTML(blogContent.dataset.conteudo_home);
                blogContent.innerHTML = htmlParsed;
            } else console.log("SEM CONTEUDO ;");
        });
    }
    richTextParse();
}


function $be797302e9a2fcac$export$2e2bcd8739ae039() {
    function richTextParse() {
        function parseJSONToHTML(json) {
            const data = JSON.parse(json);
            let html = "";
            for (const block of data.blocks)switch(block.type){
                case "paragraph":
                    html += `<p class="paragraph">${block.data.text}</p>`;
                    break;
                case "Header":
                    html += `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                    break;
                case "Table":
                    html += `<table class="table">${block.data.content}</table>`;
                    break;
                case "Raw":
                    html += `<div class="raw">${block.data.html}</div>`;
                    break;
                case "Delimiter":
                    html += '<hr class="delimiter">';
                    break;
                case "Code":
                    html += `<pre class="code"><code>${block.data.code}</code></pre>`;
                    break;
                case "Quote":
                    html += `<blockquote class="quote">${block.data.text}</blockquote>`;
                    break;
                case "List":
                    const listItems = block.data.items.map((item)=>`<li>${item}</li>`).join("");
                    const listStyle = block.data.style === "ordered" ? "ol" : "ul";
                    html += `<${listStyle} class="list">${listItems}</${listStyle}>`;
                    break;
                case "Embed":
                    html += `<div class="embed ${block.data.service}">
								<iframe width="560" height="315" src="${block.data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
								</div>`;
                    break;
                case "Checklist":
                    const checklistItems = block.data.items.map((item)=>{
                        const checked = item.checked ? "checked" : "";
                        return `<li>
									<input  type="checkbox" onclick="return false;"  ${checked}>
									<label> ${item.text} </label>
									</li>`;
                    }).join("");
                    html += `<ul>${checklistItems}</ul>`;
                    break;
                case "Image":
                    html += `<img src="${block.data.file.url}" alt="${block.data.caption}" class="image">`;
                    break;
                case "Warning":
                    html += `<div class="warning">
															<h3>${block.data.title}</h3>
															<p>${block.data.message}</p>
															</div>`;
                    break;
                default:
                    break;
            }
            return html;
        }
        const blogContent = document.querySelectorAll(".text-content");
        blogContent.forEach((item)=>{
            console.log("dataset", item.dataset);
            if (item.dataset.descricaoConteudo) {
                const htmlParsed = parseJSONToHTML(item.dataset.descricaoConteudo);
                item.innerHTML = htmlParsed;
            } else console.log("SEM CONTEUDO ;");
        });
    // if (blogContent.dataset.conteudo_home) {
    //   const htmlParsed = parseJSONToHTML(blogContent.dataset.conteudo_home);
    //   blogContent.innerHTML = htmlParsed;
    // } else {
    //   console.log("SEM CONTEUDO ;");
    // }
    }
    richTextParse();
}


function $8dd851962ecf29a7$export$2e2bcd8739ae039() {
    function richTextParse() {
        function parseJSONToHTML(json) {
            const data = JSON.parse(json);
            let html = "";
            for (const block of data.blocks)switch(block.type){
                case "paragraph":
                    html += `<p class="paragraph">${block.data.text}</p>`;
                    break;
                case "Header":
                    html += `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                    break;
                case "Table":
                    html += `<table class="table">${block.data.content}</table>`;
                    break;
                case "Raw":
                    html += `<div class="raw">${block.data.html}</div>`;
                    break;
                case "Delimiter":
                    html += '<hr class="delimiter">';
                    break;
                case "Code":
                    html += `<pre class="code"><code>${block.data.code}</code></pre>`;
                    break;
                case "Quote":
                    html += `<blockquote class="quote">${block.data.text}</blockquote>`;
                    break;
                case "List":
                    const listItems = block.data.items.map((item)=>`<li>${item}</li>`).join("");
                    const listStyle = block.data.style === "ordered" ? "ol" : "ul";
                    html += `<${listStyle} class="list">${listItems}</${listStyle}>`;
                    break;
                case "Embed":
                    html += `<div class="embed ${block.data.service}">
								<iframe width="560" height="315" src="${block.data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
								</div>`;
                    break;
                case "Checklist":
                    const checklistItems = block.data.items.map((item)=>{
                        const checked = item.checked ? "checked" : "";
                        return `<li>
									<input  type="checkbox" onclick="return false;"  ${checked}>
									<label> ${item.text} </label>
									</li>`;
                    }).join("");
                    html += `<ul>${checklistItems}</ul>`;
                    break;
                case "Image":
                    html += `<img src="${block.data.file.url}" alt="${block.data.caption}" class="image">`;
                    break;
                case "Warning":
                    html += `<div class="warning">
															<h3>${block.data.title}</h3>
															<p>${block.data.message}</p>
															</div>`;
                    break;
                default:
                    break;
            }
            return html;
        }
        const blogContent = document.querySelectorAll(".text-content");
        blogContent.forEach((blog)=>{
            if (blog.dataset.conteudoDescricaoEquipePt) {
                if (JSON.parse(blog.dataset.conteudoDescricaoEquipePt).blocks.length > 0) {
                    const htmlParsed = parseJSONToHTML(blog.dataset.conteudoDescricaoEquipePt);
                    blog.innerHTML = htmlParsed;
                } else blog.closest("div").style.display = "none";
            } else if (blog.dataset.conteudoDescricaoEquipeEn) {
                if (JSON.parse(blog.dataset.conteudoDescricaoEquipeEn).blocks.length > 0) {
                    const htmlParsed = parseJSONToHTML(blog.dataset.conteudoDescricaoEquipeEn);
                    blog.innerHTML = htmlParsed;
                } else blog.closest("div").style.display = "none";
            } else blog.closest("div").style.display = "none";
        });
    }
    richTextParse();
}


function $a3b450a645fcf4b4$export$2e2bcd8739ae039() {
    function richTextParse() {
        function parseJSONToHTML(json) {
            const data = JSON.parse(json);
            let html = "";
            for (const block of data.blocks)switch(block.type){
                case "paragraph":
                    html += `<p class="paragraph">${block.data.text}</p>`;
                    break;
                case "Header":
                    html += `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                    break;
                case "Table":
                    html += `<table class="table">${block.data.content}</table>`;
                    break;
                case "Raw":
                    html += `<div class="raw">${block.data.html}</div>`;
                    break;
                case "Delimiter":
                    html += '<hr class="delimiter">';
                    break;
                case "Code":
                    html += `<pre class="code"><code>${block.data.code}</code></pre>`;
                    break;
                case "Quote":
                    html += `<blockquote class="quote">${block.data.text}</blockquote>`;
                    break;
                case "List":
                    const listItems = block.data.items.map((item)=>`<li>${item}</li>`).join("");
                    const listStyle = block.data.style === "ordered" ? "ol" : "ul";
                    html += `<${listStyle} class="list">${listItems}</${listStyle}>`;
                    break;
                case "Embed":
                    html += `<div class="embed ${block.data.service}">
								<iframe width="560" height="315" src="${block.data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
								</div>`;
                    break;
                case "Checklist":
                    const checklistItems = block.data.items.map((item)=>{
                        const checked = item.checked ? "checked" : "";
                        return `<li>
									<input  type="checkbox" onclick="return false;"  ${checked}>
									<label> ${item.text} </label>
									</li>`;
                    }).join("");
                    html += `<ul>${checklistItems}</ul>`;
                    break;
                case "Image":
                    html += `<img src="${block.data.file.url}" alt="${block.data.caption}" class="image">`;
                    break;
                case "Warning":
                    html += `<div class="warning">
															<h3>${block.data.title}</h3>
															<p>${block.data.message}</p>
															</div>`;
                    break;
                default:
                    break;
            }
            return html;
        }
        const blogContent = document.querySelectorAll(".text-content");
        console.log("page ranking");
        blogContent.forEach((blog)=>{
            console.log("caiu aqui =>", blog);
            if (blog.dataset.conteudo) {
                const htmlParsed = parseJSONToHTML(blog.dataset.conteudo);
                blog.innerHTML = htmlParsed;
            }
            if (blog.dataset.conteudoEn) {
                const htmlParsed = parseJSONToHTML(blog.dataset.conteudoEn);
                blog.innerHTML = htmlParsed;
            } else console.log("SEM CONTEUDO ;");
        });
    }
    richTextParse();
}


function $8548f3df64a53e97$export$2e2bcd8739ae039() {
    const pageReconhecimento = document.querySelector('#premios-reconhecimentos');
    const itemList = document.querySelectorAll('.item-lista');
    const contentActive = document.querySelectorAll('.tab-content');
    const url = window.location.href;
    let filtroUrl = url.includes('?page');
    if (filtroUrl && pageReconhecimento) {
        itemList[0].classList.remove('ativo');
        itemList[1].classList.add('ativo');
        contentActive[0].classList.remove('ativo');
        contentActive[1].classList.add('ativo');
        console.log(filtroUrl);
    }
} /*
itemList[0].classList.remove('ativo')
itemList[1].classList.add('ativo')

contentActive[0].classList.remove('ativo')
contentActive[1].classList.add('ativo')
*/ 


function $d6f6f435be4d5226$export$2e2bcd8739ae039() {
    const modal = document.getElementById('iba-modal');
    if (!modal) return;
    function openModal() {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
    function closeModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    }
    modal.querySelectorAll('[data-iba-modal-close]').forEach((el)=>{
        el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });
    openModal();
}


(0, $8548f3df64a53e97$export$2e2bcd8739ae039)();
(0, $6074568c9c4450be$export$2e2bcd8739ae039)();
(0, $2914c72b259257f0$export$2e2bcd8739ae039)();
if (window.AOS) AOS.init({
    disable: function() {
        var maxWidth = 768;
        return window.innerWidth < maxWidth;
    },
    startEvent: "DOMContentLoaded",
    offset: 30,
    delay: 800,
    duration: 800,
    easing: "ease",
    once: true
});
(0, $20b7ac172908ca81$export$2e2bcd8739ae039)();
(0, $4e4a35de138e9f7d$export$2e2bcd8739ae039)();
(0, $999c07c981819f1e$export$2e2bcd8739ae039)();
(0, $e7d2b4c92d82f8e3$export$2e2bcd8739ae039)();
(0, $dde89147b3a6dc75$export$2e2bcd8739ae039)();
(0, $3ef47403202fb23b$export$2e2bcd8739ae039)(".select-lang");
(0, $e45bd7d33e1e9fe5$export$2e2bcd8739ae039)();
// PAGES
const $ad253d60d7afe5ec$var$pageHome = document.querySelector(".body-home");
const $ad253d60d7afe5ec$var$pageSobre = document.querySelector(".body-sobre");
const $ad253d60d7afe5ec$var$singlePage = document.querySelector(".body-single-page");
const $ad253d60d7afe5ec$var$pageEquipe = document.querySelector(".body-equipe");
const $ad253d60d7afe5ec$var$pageAreas = document.querySelector(".body-areas-atuacao");
const $ad253d60d7afe5ec$var$pageSingleEquipe = document.querySelector(".body-single-equipe");
const $ad253d60d7afe5ec$var$pageEquipeDetalhe = document.querySelector("#nossa-equipe-detalhe");
// ★ Pages Scopo
if ($ad253d60d7afe5ec$var$pageHome) {
    (0, $4937a915b72f1eb1$export$2e2bcd8739ae039)();
    (0, $c575fedb0aafb31c$export$2e2bcd8739ae039)();
// mottaIbaModal(); // Desativado: modal de agendamento não deve mais aparecer ao entrar na home
} else if ($ad253d60d7afe5ec$var$pageSobre) {
    (0, $08a0bb1a2b8dee1f$export$2e2bcd8739ae039)();
    (0, $cb94ac20dc347dbd$export$2e2bcd8739ae039)();
    (0, $be797302e9a2fcac$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$singlePage) {
    const swiperNossoTime = new Swiper(".teste", {
        slidesPerView: 1.2,
        spaceBetween: 50,
        breakpoints: {
            540: {
                slidesPerView: 2,
                spaceBetween: 100
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 80
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 200
            }
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });
} else if ($ad253d60d7afe5ec$var$pageEquipe) (0, $573220700407d05d$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageEquipeDetalhe) (0, $8dd851962ecf29a7$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageAreas) (0, $e1031f0fb6508262$export$2e2bcd8739ae039)();
else if ($ad253d60d7afe5ec$var$pageSingleEquipe) (0, $a3b450a645fcf4b4$export$2e2bcd8739ae039)();
document.addEventListener("DOMContentLoaded", ()=>document.body.classList.add("dcl"));
document.querySelector("body").addEventListener("dblclick", function(event) {
    event.preventDefault();
});

})();
//# sourceMappingURL=main.js.map
